<template>
  <el-dialog
    :title="dialogTitle"
    :visible="visible"
    width="1120px"
    top="4vh"
    append-to-body
    @close="close"
  >
    <el-alert
      v-if="manualPolicy"
      title="未查询到该保单，已切换为手工登记，请补充完整保单信息。"
      type="warning"
      :closable="false"
      show-icon
      class="policy-alert"
    />
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="120px"
      :disabled="mode === 'view'"
    >
      <h3 class="section-title">保单信息</h3>
      <el-row :gutter="20">
        <el-col :span="12"
          ><el-form-item label="保单号码" prop="policy_no"
            ><el-input
              v-model.trim="form.policy_no"
              :disabled="mode !== 'create' || policyLoaded"
              ><el-button
                v-if="mode === 'create' && !policyLoaded"
                slot="append"
                :loading="querying"
                @click="loadPolicyInfo"
                >查询</el-button
              ></el-input
            ></el-form-item
          ></el-col
        >
        <el-col :span="12"
          ><el-form-item label="产品名称" prop="product_id"
            ><el-select
              v-model="form.product_id"
              filterable
              clearable
              :disabled="policyLocked('product_id')"
              ><el-option
                v-for="item in products"
                :key="item.id"
                :label="item.name"
                :value="Number(item.id)"/></el-select></el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="保险公司" prop="insurer_company_id"
            ><el-select
              v-model="form.insurer_company_id"
              filterable
              clearable
              :disabled="policyLocked('insurer_company_id')"
              ><el-option
                v-for="item in companies"
                :key="item.id"
                :label="item.name"
                :value="Number(item.id)"/></el-select></el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="险种"
            ><el-input :value="riskLabels[riskType]" disabled/></el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="投保人" prop="policyholder"
            ><el-input
              v-model.trim="form.policyholder"
              :disabled="policyLocked('policyholder')"/></el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="被保险人" prop="beneficiary"
            ><el-input
              v-model.trim="form.beneficiary"
              :disabled="policyLocked('beneficiary')"/></el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="客户省份"
            ><el-select
              v-model="form.customer_province"
              filterable
              clearable
              :disabled="policyLocked('customer_province')"
              @change="loadCustomerCities"
              ><el-option
                v-for="item in provinces"
                :key="item.province"
                :label="item.province"
                :value="item.province"/></el-select></el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="客户城市"
            ><el-select
              v-model="form.customer_city"
              filterable
              clearable
              :disabled="policyLocked('customer_city')"
              ><el-option
                v-for="item in customerCities"
                :key="item.city"
                :label="item.city"
                :value="item.city"/></el-select></el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="生效时间" prop="effected_at"
            ><el-date-picker
              v-model="form.effected_at"
              type="date"
              value-format="yyyy-MM-dd"
              :disabled="policyLocked('effected_at')"/></el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="失效时间" prop="expired_at"
            ><el-date-picker
              v-model="form.expired_at"
              type="date"
              value-format="yyyy-MM-dd"
              :disabled="policyLocked('expired_at')"/></el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="保费" prop="pay_price"
            ><el-input-number
              v-model="form.pay_price"
              :min="0"
              :precision="2"
              :controls="false"
              :disabled="policyLocked('pay_price')"
            /><span class="unit">元</span></el-form-item
          ></el-col
        >
        <el-col :span="12"
          ><el-form-item label="顶级渠道"
            ><el-select
              v-model="form.top_channel_id"
              filterable
              clearable
              :disabled="policyLocked('top_channel_id')"
              ><el-option
                v-for="item in channels"
                :key="item.id"
                :label="item.realname || item.name"
                :value="Number(item.id)"/></el-select></el-form-item
        ></el-col>
      </el-row>

      <h3 class="section-title">案件信息</h3>
      <el-row :gutter="20">
        <el-col :span="12"
          ><el-form-item label="出险日期" prop="risk_at"
            ><el-date-picker
              v-model="form.risk_at"
              type="date"
              value-format="yyyy-MM-dd"/></el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="报案号码" prop="claims_number"
            ><el-input
              v-model.trim="form.claims_number"
              maxlength="64"/></el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="估损金额"
            ><el-input-number
              v-model="form.estimated_amount"
              :min="0"
              :precision="2"
              :controls="false"
            /><span class="unit">元</span></el-form-item
          ></el-col
        >
        <el-col :span="12"
          ><el-form-item label="事故后果"
            ><el-select v-model="form.accident_consequences" clearable
              ><el-option
                v-for="item in consequences"
                :key="item"
                :label="item"
                :value="item"/></el-select></el-form-item
        ></el-col>
        <template v-if="riskType === 1">
          <el-col :span="12"
            ><el-form-item label="货物类型"
              ><el-select
                v-model="form.cargo_type_id"
                filterable
                clearable
                @change="loadCargoNames"
                ><el-option
                  v-for="item in cargoTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="Number(item.id)"/></el-select></el-form-item
          ></el-col>
          <el-col :span="12"
            ><el-form-item label="货物品名"
              ><el-select v-model="form.cargo_id" filterable clearable
                ><el-option
                  v-for="item in cargoNames"
                  :key="item.id"
                  :label="item.name"
                  :value="Number(item.id)"/></el-select></el-form-item
          ></el-col>
          <el-col :span="12"
            ><el-form-item label="出险路段"
              ><el-select v-model="form.risk_rold" clearable
                ><el-option
                  v-for="item in roads"
                  :key="item"
                  :label="item"
                  :value="item"/></el-select></el-form-item
          ></el-col>
          <el-col :span="12"
            ><el-form-item label="详细地址"
              ><el-input
                v-model.trim="form.detailed_address"
                maxlength="255"/></el-form-item
          ></el-col>
        </template>
        <template v-else>
          <el-col :span="12"
            ><el-form-item label="伤者姓名"
              ><el-input v-model.trim="form.wounded_name"/></el-form-item
          ></el-col>
          <el-col :span="12"
            ><el-form-item label="伤者工种"
              ><el-select v-model="form.wounded_jobs" clearable
                ><el-option
                  v-for="(label, value) in jobs"
                  :key="value"
                  :label="label"
                  :value="Number(value)"/></el-select></el-form-item
          ></el-col>
          <el-col :span="12"
            ><el-form-item label="身份证号"
              ><el-input
                v-model.trim="form.wounded_id_card"
                maxlength="18"/></el-form-item
          ></el-col>
        </template>
        <el-col :span="12"
          ><el-form-item label="出险省份"
            ><el-select
              v-model="form.risk_province"
              filterable
              clearable
              @change="loadRiskCities"
              ><el-option
                v-for="item in provinces"
                :key="item.province"
                :label="item.province"
                :value="item.province"/></el-select></el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="出险城市"
            ><el-select v-model="form.risk_city" filterable clearable
              ><el-option
                v-for="item in riskCities"
                :key="item.city"
                :label="item.city"
                :value="item.city"/></el-select></el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="案件定性"
            ><el-select v-model="form.identity_id" filterable clearable
              ><el-option
                v-for="item in identities"
                :key="item.id"
                :label="item.name"
                :value="Number(item.id)"/></el-select></el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="原因一级"
            ><el-select
              v-model="form.reason_id_one"
              filterable
              clearable
              @change="loadReasonTwo"
              ><el-option
                v-for="item in reasonsOne"
                :key="item.id"
                :label="item.name"
                :value="Number(item.id)"/></el-select></el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="原因二级"
            ><el-select
              v-model="form.reason_id_two"
              filterable
              clearable
              @change="loadReasonThree"
              ><el-option
                v-for="item in reasonsTwo"
                :key="item.id"
                :label="item.name"
                :value="Number(item.id)"/></el-select></el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="原因三级"
            ><el-select v-model="form.reason_id_three" filterable clearable
              ><el-option
                v-for="item in reasonsThree"
                :key="item.id"
                :label="item.name"
                :value="Number(item.id)"/></el-select></el-form-item
        ></el-col>
        <el-col :span="24"
          ><el-form-item label="案件经过"
            ><el-input
              v-model="form.case_process"
              type="textarea"
              :rows="3"
              maxlength="1000"
              show-word-limit/></el-form-item
        ></el-col>
        <el-col :span="24"
          ><el-form-item label="备注"
            ><el-input
              v-model="form.content"
              type="textarea"
              :rows="3"
              maxlength="512"
              show-word-limit/></el-form-item
        ></el-col>
      </el-row>
    </el-form>
    <span slot="footer"
      ><el-button @click="close">{{
        mode === "view" ? "关闭" : "取消"
      }}</el-button
      ><el-button
        v-if="mode !== 'view'"
        type="primary"
        :loading="saving"
        @click="submit"
        >保存</el-button
      ></span
    >
  </el-dialog>
</template>

<script>
import {
  getClaimInfo,
  getPolicyInfo,
  saveClaim,
  updateClaim,
  getInsuranceCompanies,
  getProducts,
  getTopChannels,
  getProvinces,
  getCities,
  getCargoTypes,
  getCargoNames,
  getIdentities,
  getReasons
} from "@/api/claims-management";
import {
  RISK_LABELS,
  RISK_KEYS,
  JOBS,
  CARGO_CONSEQUENCES,
  EMPLOYER_CONSEQUENCES,
  ROAD_TYPES,
  formatDate,
  fromCents,
  toCents,
  toTimestamp
} from "../constants";

const emptyForm = () => ({
  policy_no: "",
  product_id: null,
  insurer_company_id: null,
  policyholder: "",
  beneficiary: "",
  customer_province: "",
  customer_city: "",
  effected_at: "",
  expired_at: "",
  pay_price: 0,
  top_channel_id: null,
  risk_at: "",
  claims_number: "",
  estimated_amount: 0,
  cargo_type_id: null,
  cargo_id: null,
  accident_consequences: "",
  risk_province: "",
  risk_city: "",
  risk_rold: "",
  detailed_address: "",
  wounded_name: "",
  wounded_jobs: null,
  wounded_id_card: "",
  identity_id: null,
  reason_id_one: null,
  reason_id_two: null,
  reason_id_three: null,
  case_process: "",
  content: ""
});

export default {
  name: "ClaimEditor",
  props: {
    visible: Boolean,
    mode: { type: String, default: "create" },
    riskType: Number,
    claimId: [String, Number],
    policyNo: String
  },
  data() {
    return {
      saving: false,
      querying: false,
      policyLoaded: false,
      manualPolicy: false,
      lockedFields: [],
      orderId: 0,
      form: emptyForm(),
      riskLabels: RISK_LABELS,
      jobs: JOBS,
      roads: ROAD_TYPES,
      products: [],
      companies: [],
      channels: [],
      provinces: [],
      customerCities: [],
      riskCities: [],
      cargoTypes: [],
      cargoNames: [],
      identities: [],
      reasonsOne: [],
      reasonsTwo: [],
      reasonsThree: [],
      rules: {
        policy_no: [
          { required: true, message: "请输入保单号码", trigger: "blur" }
        ],
        product_id: [
          { required: true, message: "请选择产品", trigger: "change" }
        ],
        insurer_company_id: [
          { required: true, message: "请选择保险公司", trigger: "change" }
        ],
        policyholder: [
          { required: true, message: "请输入投保人", trigger: "blur" }
        ],
        beneficiary: [
          { required: true, message: "请输入被保险人", trigger: "blur" }
        ],
        effected_at: [
          { required: true, message: "请选择生效时间", trigger: "change" }
        ],
        expired_at: [
          { required: true, message: "请选择失效时间", trigger: "change" }
        ],
        pay_price: [{ required: true, message: "请输入保费", trigger: "blur" }],
        risk_at: [
          { required: true, message: "请选择出险日期", trigger: "change" }
        ],
        claims_number: [
          { required: true, message: "请输入报案号码", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    dialogTitle() {
      return `${
        this.mode === "create" ? "登记" : this.mode === "edit" ? "编辑" : "查看"
      }${this.riskLabels[this.riskType]}案件`;
    },
    consequences() {
      return this.riskType === 1 ? CARGO_CONSEQUENCES : EMPLOYER_CONSEQUENCES;
    }
  },
  watch: {
    visible(value) {
      if (value) this.initialize();
    }
  },
  methods: {
    async initialize() {
      this.form = emptyForm();
      this.policyLoaded = false;
      this.manualPolicy = false;
      this.lockedFields = [];
      this.orderId = 0;
      this.cargoNames = [];
      this.reasonsTwo = [];
      this.reasonsThree = [];
      await this.loadBaseOptions();
      if (this.mode === "create") {
        this.form.policy_no = this.policyNo || "";
        if (this.form.policy_no) await this.loadPolicyInfo();
      } else {
        const res = await getClaimInfo(RISK_KEYS[this.riskType], {
          id: Number(this.claimId)
        });
        await this.applyData(res.data || {});
      }
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
    },
    async loadBaseOptions() {
      const [
        products,
        companies,
        channels,
        provinces,
        cargoTypes,
        identities,
        reasons
      ] = await Promise.all([
        getProducts({ page: 1, rows: 1000 }),
        getInsuranceCompanies({ page: 1, rows: 1000 }),
        getTopChannels({ page: 1, rows: 1000 }),
        getProvinces({ page: 1, rows: 1000 }),
        this.riskType === 1
          ? getCargoTypes({ page: 1, rows: 1000, disabled: true })
          : Promise.resolve({ rows: [] }),
        getIdentities({
          page: 1,
          rows: 1000,
          risk_type: this.riskType,
          disabled: true
        }),
        getReasons("levelone", {
          page: 1,
          rows: 1000,
          risk_type: this.riskType,
          disabled: true
        })
      ]);
      this.products = products.rows || [];
      this.companies = companies.rows || [];
      this.channels = channels.rows || [];
      this.provinces = provinces.rows || [];
      this.cargoTypes = cargoTypes.rows || [];
      this.identities = identities.rows || [];
      this.reasonsOne = reasons.rows || [];
    },
    async loadPolicyInfo() {
      if (!this.form.policy_no) return this.$message.warning("请输入保单号码");
      this.querying = true;
      try {
        const res = await getPolicyInfo(RISK_KEYS[this.riskType], {
          policy_no: this.form.policy_no
        });
        if (res.err_code === 1108) {
          this.manualPolicy = true;
          this.policyLoaded = false;
          this.lockedFields = [];
          return;
        }
        this.manualPolicy = false;
        this.policyLoaded = true;
        this.orderId = Number(res.data.order_id || 0);
        await this.applyData({ ...this.form, ...res.data }, true);
      } finally {
        this.querying = false;
      }
    },
    async applyData(data, fromPolicy = false) {
      const normalized = { ...emptyForm(), ...data };
      normalized.pay_price = Number(fromCents(data.pay_price) || 0);
      normalized.estimated_amount = Number(
        fromCents(data.estimated_amount) || 0
      );
      ["effected_at", "expired_at", "risk_at"].forEach(key => {
        normalized[key] =
          formatDate(data[key]) === "-" ? "" : formatDate(data[key]);
      });
      if (data.employee) {
        normalized.wounded_name = normalized.wounded_name || data.employee.name;
        normalized.wounded_id_card =
          normalized.wounded_id_card || data.employee.idcard;
        normalized.wounded_jobs = normalized.wounded_jobs || data.employee.type;
      }
      [
        "product_id",
        "insurer_company_id",
        "top_channel_id",
        "cargo_type_id",
        "cargo_id",
        "wounded_jobs",
        "identity_id",
        "reason_id_one",
        "reason_id_two",
        "reason_id_three"
      ].forEach(key => {
        normalized[key] = normalized[key] ? Number(normalized[key]) : null;
      });
      this.form = normalized;
      this.orderId = Number(data.order_id || this.orderId || 0);
      if (fromPolicy)
        this.lockedFields = [
          "product_id",
          "insurer_company_id",
          "policyholder",
          "beneficiary",
          "customer_province",
          "customer_city",
          "effected_at",
          "expired_at",
          "pay_price",
          "top_channel_id"
        ].filter(
          key =>
            data[key] !== null &&
            data[key] !== undefined &&
            data[key] !== "" &&
            data[key] !== 0
        );
      if (normalized.customer_province)
        await this.loadCustomerCities(normalized.customer_province, true);
      if (normalized.risk_province)
        await this.loadRiskCities(normalized.risk_province, true);
      if (normalized.cargo_type_id)
        await this.loadCargoNames(normalized.cargo_type_id, true);
      if (normalized.reason_id_one)
        await this.loadReasonTwo(normalized.reason_id_one, true);
      if (normalized.reason_id_two)
        await this.loadReasonThree(normalized.reason_id_two, true);
    },
    async loadCities(province) {
      if (!province) return [];
      const res = await getCities({ province });
      return res.data || res.rows || [];
    },
    async loadCustomerCities(province, preserve = false) {
      if (!preserve) this.form.customer_city = "";
      this.customerCities = await this.loadCities(province);
    },
    async loadRiskCities(province, preserve = false) {
      if (!preserve) this.form.risk_city = "";
      this.riskCities = await this.loadCities(province);
    },
    async loadCargoNames(id, preserve = false) {
      if (!preserve) this.form.cargo_id = null;
      if (!id) {
        this.cargoNames = [];
        return;
      }
      const res = await getCargoNames({
        cargo_type_id: id,
        disabled: true,
        page: 1,
        rows: 1000
      });
      this.cargoNames = res.rows || [];
    },
    async loadReasonTwo(id, preserve = false) {
      if (!preserve) {
        this.form.reason_id_two = null;
        this.form.reason_id_three = null;
      }
      this.reasonsThree = [];
      if (!id) {
        this.reasonsTwo = [];
        return;
      }
      const res = await getReasons("leveltwo", {
        parent_id: id,
        disabled: true,
        page: 1,
        rows: 1000
      });
      this.reasonsTwo = res.rows || [];
    },
    async loadReasonThree(id, preserve = false) {
      if (!preserve) this.form.reason_id_three = null;
      if (!id) {
        this.reasonsThree = [];
        return;
      }
      const res = await getReasons("levelthree", {
        parent_id: id,
        disabled: true,
        page: 1,
        rows: 1000
      });
      this.reasonsThree = res.rows || [];
    },
    policyLocked(key) {
      return this.mode === "view" || this.lockedFields.includes(key);
    },
    submit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        this.saving = true;
        try {
          const data = {
            ...this.form,
            risk_type: Number(this.riskType),
            pay_price: toCents(this.form.pay_price),
            estimated_amount: toCents(this.form.estimated_amount),
            effected_at: toTimestamp(this.form.effected_at),
            expired_at: toTimestamp(this.form.expired_at),
            risk_at: toTimestamp(this.form.risk_at)
          };
          [
            "product_id",
            "insurer_company_id",
            "top_channel_id",
            "cargo_type_id",
            "cargo_id",
            "wounded_jobs",
            "identity_id",
            "reason_id_one",
            "reason_id_two",
            "reason_id_three"
          ].forEach(key => {
            data[key] = data[key] ? Number(data[key]) : 0;
          });
          if (this.mode === "edit") {
            data.id = Number(this.claimId);
            await updateClaim(RISK_KEYS[this.riskType], data);
          } else {
            data.order_id = Number(this.orderId || 0);
            await saveClaim(RISK_KEYS[this.riskType], data);
          }
          this.$message.success(this.mode === "edit" ? "编辑成功" : "登记成功");
          this.$emit("saved");
          this.close();
        } finally {
          this.saving = false;
        }
      });
    },
    close() {
      this.$emit("update:visible", false);
    }
  }
};
</script>

<style scoped>
.policy-alert {
  margin-bottom: 14px;
}
.section-title {
  margin: 5px 0 18px;
  padding-left: 10px;
  border-left: 4px solid #409eff;
  color: #303133;
}
.unit {
  margin-left: 8px;
  color: #909399;
}
/deep/ .el-select,
/deep/ .el-date-editor,
/deep/ .el-input-number {
  width: 100%;
}
</style>
